import {
  DeleteNotificationRequest,
  GetNotificationsRequest,
  GetNotificationsResponse,
} from "@/types/notificationTypes";
import {createApi, FetchArgs} from "@reduxjs/toolkit/query/react";
import platformAuthConfig from "./platformConfig";

export type TagTypes = "Notifications";

const notificationsApi = createApi({
  reducerPath: "notificationsApi",
  ...platformAuthConfig(),
  tagTypes: ["Notifications"],
  endpoints: (builder) => ({
    getNotifications: builder.query<
      GetNotificationsResponse,
      GetNotificationsRequest
    >({
      query: ({org_id, page = 1, page_size = 10}): FetchArgs => ({
        url: `/${org_id}/notifications/`,
        method: "GET",
        params: {page, page_size},
      }),
      providesTags: (_result, _error, {page}) => [
        {type: "Notifications", id: `PAGE_${page}`},
        {type: "Notifications", id: "LIST"},
      ],
    }),
    getNotificationCount: builder.query<
      GetNotificationsResponse,
      string
    >({
      query: (org_id): FetchArgs => ({
        url: `/${org_id}/notifications/`,
        method: "GET",
        params: {page: 1, page_size: 1},
      }),
      providesTags: [{type: "Notifications", id: "COUNT"}],
    }),
    deleteNotifications: builder.mutation<void, DeleteNotificationRequest>({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/notifications/${config.notification_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useGetNotificationCountQuery,
  useDeleteNotificationsMutation,
} = notificationsApi;

export default notificationsApi;
